import { createReducer } from '../helpers';
import { api } from '../actions';

const initialState = {
    isFetching: true,
    result: null,
    error: null,
};

export default createReducer(initialState, {
    [api.billing.details.request]: (state, action) => {
        state.isFetching = true;
        state.error = null;
    },
    [api.billing.details.success]: (state, action) => {
        state.isFetching = false;
        state.result = action.result;
    },
    [api.billing.details.failure]: (state, action) => {
        state.isFetching = false;
        state.error = action.error;
    },
    [api.billing.update.success]: (state, action) => {
        state.result = action.result;
    },
    [api.billing.applyCoupon.success]: (state, action) => {
        state.result = action.result;
    },
});
